import GlobalStyles from '@mui/material/GlobalStyles'
import { ThemeProvider } from '@mui/system'
import { Amplify } from 'aws-amplify'
import { globalStyles, theme } from 'config'
import awsConfig from 'config/awsExport'
import { AuthProvider, SidebarProvider } from 'context'
import { SnackbarProvider } from 'notistack'
import ReactGA from 'react-ga4'
import { AppRoutes } from 'routes'
import { MaintenanceProvider } from 'context/maintenance'

ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS}`)

Amplify.configure(awsConfig)

function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <SidebarProvider>
          <MaintenanceProvider>
            <SnackbarProvider
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
            >
              <GlobalStyles styles={globalStyles} />
              <AppRoutes />
            </SnackbarProvider>
          </MaintenanceProvider>
        </SidebarProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
